import { storyblokEditable, StoryblokComponent } from '@storyblok/react'
import { TwoColumnStoryblok } from '@/component-types-sb'

export default function TwoColumn({ blok }: { blok: TwoColumnStoryblok }) {
    const leftContent = blok.left || []
    const rightContent = blok.right || []

    return (
        <div {...storyblokEditable(blok)} className="twoColumn max-w-[1200px] mx-auto">
            {blok.heading && <h2 id={blok.heading} className="p-5 md:p-10">{blok.heading}</h2>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div>
                    {leftContent.map((nestedBlok) => (
                        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
                    ))}
                </div>
                <div>
                    {rightContent.map((nestedBlok) => (
                        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
                    ))}
                </div>
            </div>
        </div>
    )
}
